import { makeStyles, Grid, Typography, Table, TableBody, TableCell, TableRow, TableHead, TableContainer } from '@material-ui/core';
import React from 'react';
import { EnumCaixaTipoLancamento } from '@model/CaixaTipoLancamento';
import { useParams } from 'react-router-dom';
import useFormatter from '@hooks/useFormatter';
import useMessage from '@hooks/useMessage';
import { ICaixaImpressaoResponse, useCaixaService } from '@services/CaixaService';
import { TableHeaderCell } from '@components/Table/TableHeaderCell';

type CaixaImpressaoProps = {
}

type CaixaImpressaoParams = {
    caixaId?: string,
    periodoDe: string,
    periodoAte: string,
}

export function CaixaImpressao (props: CaixaImpressaoProps) {
    const [caixaImpressao, setCaixaImpressao] = React.useState<ICaixaImpressaoResponse>();

    const params = useParams<CaixaImpressaoParams>();

    const caixaId = React.useMemo(() => params.caixaId !== undefined ? parseInt(params.caixaId) : undefined, [params.caixaId]);
    const periodoDe = React.useMemo(() => new Date(params.periodoDe), [params.periodoDe]);
    const periodoAte = React.useMemo(() => new Date(params.periodoAte), [params.periodoAte]);
    
    const cls = useStyles();

    const message = useMessage();
    const formatter = useFormatter();

    const caixaService = useCaixaService();

    React.useEffect(() => {
        caixaService.carregarCaixaImpressao(periodoDe, periodoAte, caixaId)
            .then(response => {
                setCaixaImpressao(response.data);
            })
            .catch(message.showException);
    // eslint-disable-next-line
    }, []);

    return (
        <div className={cls.root}>
            <Grid container className={cls.header} alignItems="flex-start">
                <Grid item>
                    <Typography>Caixa de <b>{caixaImpressao?.nome}</b></Typography>
                    <Typography>Período: <b>{periodoDe.toLocaleDateString()}</b> até <b>{periodoAte.toLocaleDateString()}</b></Typography>                    
                </Grid>
                <Grid item style={{marginLeft: 'auto'}}>
                    <Typography variant="body2">Data/Hora Relatório: <b>{new Date().toLocaleString()}</b></Typography>
                </Grid>
            </Grid>

            <TableContainer>
                <Table className={cls.table}>
                    <TableHead>
                        <TableRow>
                            <TableHeaderCell>ID</TableHeaderCell>
                            <TableHeaderCell>Data</TableHeaderCell>
                            <TableHeaderCell>Descrição</TableHeaderCell>
                            <TableHeaderCell>Débito</TableHeaderCell>
                            <TableHeaderCell>Crédito</TableHeaderCell>
                            <TableHeaderCell>Saldo</TableHeaderCell>
                        </TableRow>
                    </TableHead>

                    <TableBody>
                    {
                        caixaImpressao?.itens.map((record, index) => {
                            return (
                                <TableRow key={index}>
                                    <TableCell>{record.caixaItemId !== undefined ? record.caixaItemId : ""}</TableCell>
                                    <TableCell>{formatter.toDate(record.dataHora)}</TableCell>
                                    <TableCell>{record.descricao}</TableCell>
                                    <TableCell>{record.caixaTipoLancamentoId === EnumCaixaTipoLancamento.Debito ? formatter.toFloat(record.valor) : ""}</TableCell>
                                    <TableCell>{record.caixaTipoLancamentoId === EnumCaixaTipoLancamento.Credito ? formatter.toFloat(record.valor) : ""}</TableCell>
                                    <TableCell>{formatter.toFloat(record.saldo)}</TableCell>
                                </TableRow>
                            )
                        })
                    }
                    </TableBody>
                </Table>
            </TableContainer>

            <Grid container>
                <Grid item className={cls.assinatura}>
                    <Typography><i>Assinatura</i></Typography>
                </Grid>
            </Grid>
        </div>
    )
}

const useStyles = makeStyles(theme => ({
    root: {
        padding: theme.spacing(3)
    },

    table: {
        '& th': {
            fontWeight: 'bold'
        }
    },

    header: {
        marginBottom: theme.spacing(3)
    },

    assinatura: {
        marginTop: theme.spacing(10),
        marginLeft: 'auto',
        borderTop: `2px solid ${theme.palette.divider}`,
        textAlign: 'center',
        width: '35%'
    }
}));